












































































































































import { Component, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Ticket from "@/store/entities/ticket";

@Component({
  components: {},
})
export default class TicketDetail extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  @Prop({
    type: Number,
    default: () => {
      return 0;
    },
  })
  id: number;
  ticket: Ticket = new Ticket();
  save() {
    this.$emit("input", false);
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      console.log(this.id, "this.id");
      if (this.id) {
        this.ticket = await this.$store.dispatch({
          type: "ticket/get",
          id: this.id,
        });
        console.log(this.ticket, "me");
      }
    }
  }
}
